var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13688 3.13655C8.87719 2.87686 8.45615 2.87686 8.19646 3.13655C7.93693 3.39608 7.93674 3.81679 8.19604 4.07655L11.4467 7.33301L2.66667 7.33301C2.29848 7.33301 2 7.63148 2 7.99967C2 8.36786 2.29848 8.66634 2.66667 8.66634L11.4467 8.66634L8.19397 11.9132C7.93227 12.1744 7.93208 12.5984 8.19355 12.8599C8.45484 13.1212 8.87849 13.1212 9.13979 12.8599L12.5858 9.41389C13.3668 8.63284 13.3668 7.36651 12.5858 6.58546L9.13688 3.13655Z",
    fill: "#40437A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a5546675.svg";
export { ForwardRef as ReactComponent };